<template>
    <div id="form-separation-element">
        <div class="form-separation-element">
            <hr :style="hrStyle">
        </div>
    </div>
</template>
<script>
export default {
    name: "FormSeparationElement",
    props: {
        separationColor: {
            type: String,
            required: true,
        },
        separatorStyle: {
            type: String,
            required: true,
        },
        separatorHeight: {
            type: String,
            required: true,
        },
        separatorBottom: {
            type: String,
            required: true,
        },
        separatorTop: {
            type: String,
            required: true,
        },
        separatorSide: {
            type: String,
            required: true,
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        }
    },
    computed: {
        hrStyle() {
            return {
                backgroundColor: this.separationColor,
                height: this.separatorHeight + "px",
                marginTop: this.separatorTop + "px",
                marginBottom: this.separatorBottom + "px",
                marginLeft: this.separatorSide + "px",
                marginRight: this.separatorSide + "px",
                border: "none",
            };
        },
    },

};
</script>
<style lang="scss" scoped>
#form-separation-element {
    .form-separation-element {
        cursor: all-scroll;
        margin-top: 15px;

        hr {
            background-color: #d3d3d3;
            height: 1px;
            margin: 10px 0;
            border: none;
        }
    }
}
</style>